export function formatDate(date, delimiter = ".") {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  return `${year}${delimiter}${month + 1}${delimiter}${day}`;
}
export function removeHTMLTag(raw) {
  return raw.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
}
export function extractDescription(raw) {
  return raw.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "").replace(/\r?\n/g, "").slice(100);
}
//# sourceMappingURL=index.js.map
